"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _templates = require("../../../CreateGift/store/templates/templates.selector");

var _useTrackGiftingFlow = require("../../../CreateGift/hooks/useTrackGiftingFlow");

var _gift = require("../../../CreateGift/store/gift/gift.actions");

var _message = require("../../../CreateGift/store/gift/postcard/message");

var _root = require("../../../CreateGift/store/root.selector");

var SelectSalesEmailTemplate = function SelectSalesEmailTemplate() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var templates = (0, _reactRedux.useSelector)(_templates.getTemplateList);
  var defaultTemplate = (0, _reactRedux.useSelector)(_templates.getDefaultTemplate);
  var templateFromStore = (0, _reactRedux.useSelector)(_message.getTemplateName);
  var trackStepPassed = (0, _useTrackGiftingFlow.useTrackGiftingFlowSelectTemplatePassed)();
  var isAllowEditTemplate = (0, _reactRedux.useSelector)(_root.getIsAllowEditTemplate);
  (0, _react.useEffect)(function () {
    if (!templateFromStore) {
      dispatch((0, _gift.selectTemplate)(defaultTemplate));
    }
  }, [dispatch, defaultTemplate, templateFromStore]);
  var setTemplateHandler = (0, _react.useCallback)(function (event) {
    var templateName = event.target.value;
    var template = (0, _ramda.find)((0, _ramda.pipe)((0, _ramda.prop)('name'), (0, _ramda.equals)(templateName)), templates);

    if (template) {
      trackStepPassed({
        templateType: template.type
      });
      dispatch((0, _gift.selectTemplate)(template));
    }
  }, [dispatch, templates, trackStepPassed]);
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "gift-message-select-send-as-label"
  }, "Message template"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    label: "Message template",
    labelId: "gift-message-select-template",
    value: templateFromStore,
    onChange: setTemplateHandler,
    disabled: !isAllowEditTemplate
  }, templates.map(function (template) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: template.name,
      value: template.name
    }, template.name);
  })));
};

var _default = SelectSalesEmailTemplate;
exports.default = _default;